import { IconKey,IconCpu } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconCpu
};
//

const Hardware = {

    id: 'authentication',
    title: 'Hardware Allocation',
    type: 'group',
    display_id:'H',
    icon: icons.IconCpu,
    children: [
        {
            id: 'MATM Activation Report',
            title: 'MATM Activation Report',
            type: 'item',
            display_id:40,
            url: '/Admin/MATM_Activation_Report',
            breadcrumbs: false
        },
        {
            id: 'Passbook printer Activation Report',
            title: "Passbook printer Activation Report",
            type: 'item',
            display_id: 41,
            url: '/Admin/Passbook_printer_Activation_Report',
            breadcrumbs: false
        },
        {
            id: 'Tab Activation Report',
            title: "Tab Activation Report",
            type: 'item',
            display_id: 42,
            url: '/Admin/Tab_Activation_Report',
            breadcrumbs: false
        }
    ]
}

export default Hardware;
